import { getSavedState, saveState } from '@state/helpers'

export const state = {
  apps: [],
  selectedNewAccessApp: null,
  dismissedNewAccessAppsByUser: getSavedState('apps.dismissedNewAccessAppsByUser', {}),
}

export const getters = {
  allApps(state) {
    return state.apps
  },
  favoriteApps(state) {
    return state.apps.filter((app) => app.isFavorite)
  },
  isAppFavorite(state, getters) {
    return (appId) => getters.favoriteApps.some((app) => app.appId === appId)
  },
  selectedNewAccessApp(state) {
    return state.selectedNewAccessApp
  },
  dismissedNewAccessApps(state, getters, rootState) {
    const userId = rootState.user.currentUser?.id

    if (!userId) {
      return []
    }

    return state.dismissedNewAccessAppsByUser[userId] || []
  },
  isNewAccessAppDismissed(state, getters) {
    return (appName) => getters.dismissedNewAccessApps.includes(appName)
  },
}

export const mutations = {
  SET_APPS(state, apps) {
    state.apps = apps
  },

  FAVORITE_APP_BY_ID(state, appId) {
    const appToBeFavorite = state.apps.find((app) => app.appId === appId)
    appToBeFavorite.isFavorite = true
    appToBeFavorite.favoritedAt = new Date().toISOString()
  },

  UNFAVORITE_APP_BY_ID(state, appId) {
    const appToBeUnfavorite = state.apps.find((app) => app.appId === appId)
    appToBeUnfavorite.isFavorite = false
    appToBeUnfavorite.favoritedAt = null
  },

  SET_NEW_ACCESS_APP(state, app) {
    state.selectedNewAccessApp = app
  },

  DISMISS_NEW_ACCESS_APP(state, { appName, userId }) {
    if (!appName || !userId) {
      return
    }

    const dismissedApps = state.dismissedNewAccessAppsByUser[userId] || []

    if (dismissedApps.includes(appName)) {
      return
    }

    state.dismissedNewAccessAppsByUser = {
      ...state.dismissedNewAccessAppsByUser,
      [userId]: [...dismissedApps, appName],
    }

    saveState('apps.dismissedNewAccessAppsByUser', state.dismissedNewAccessAppsByUser)
  },
}
